"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmployeeList = void 0;
var EmployeeList_1 = require("./EmployeeList");
Object.defineProperty(exports, "EmployeeList", { enumerable: true, get: function () { return EmployeeList_1.EmployeeList; } });
